import { Link } from '@tanstack/react-router'
import { Logo } from '@/components/ui/Logo'
import { siteConfig } from '@/config/site'
import { navItems } from '@/config/navigation'
import { socialLinks } from '@/config/social'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-border-subtle bg-surface-0 transition-colors duration-200">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8 py-10 sm:py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 sm:gap-10">
          {/* Brand Identity */}
          <div className="flex flex-col gap-3 max-w-sm">
            <div className="flex items-center gap-2.5">
              <Logo size={22} />
              <span className="text-lg font-bold tracking-tight text-fg">
                {siteConfig.shortName}
              </span>
            </div>
            <p className="text-sm text-fg-muted leading-relaxed">
              {siteConfig.tagline}
            </p>
          </div>

          {/* Navigation Links */}
          <nav aria-label="Footer navigation" className="w-full sm:w-auto">
            <ul className="grid grid-cols-2 sm:flex sm:flex-wrap gap-x-8 gap-y-3 sm:gap-6 list-none m-0 p-0">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="inline-block py-1 text-sm text-fg-muted hover:text-fg active:text-fg transition-colors duration-150"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-2 sm:gap-3">
            {socialLinks.map(({ label, href, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="flex items-center justify-center w-11 h-11 min-w-[44px] min-h-[44px] rounded-sm text-fg-muted hover:text-fg hover:bg-surface-2 active:bg-surface-3 transition-colors duration-150"
              >
                <Icon size={19} />
              </a>
            ))}
          </div>
        </div>

        {/* Legal & Meta Info */}
        <div className="mt-10 pt-6 border-t border-border-subtle flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-fg-muted">
          <p>
            © {currentYear} {siteConfig.name}. All rights reserved.
          </p>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs">
            <Link to="/privacy" className="hover:text-fg transition-colors py-1">
              Privacy Policy
            </Link>
            <span className="text-border-strong select-none">·</span>
            <Link to="/terms" className="hover:text-fg transition-colors py-1">
              Terms of Engagement
            </Link>
            <span className="text-border-strong select-none">·</span>
            <span className="py-1">{siteConfig.location}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
